var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6Se(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:gray;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.69,23.57l53.76,128.17c.11.27.24.53.37.78,3.87,7.39,15.07,5.41,16.69-2.77l11.29-56.96,56.96-11.29c8.18-1.62,10.16-12.82,2.77-16.69-.25-.13-.51-.25-.78-.37L23.57,10.69c-8.13-3.41-16.29,4.76-12.88,12.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 167,
    height: 167
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Se);
export default __webpack_public_path__ + "static/media/6-se.6075a8370b115f70cc537f95d5b8cecb.svg";
export { ForwardRef as ReactComponent };